import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
//files
import UploadNewRecord from './NewRecord';
import NewHeader from '../../../../models/NewHeader';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const UploadRecords = (props) => {
  const { close, open, batchDetails } = props

  let title = "Upload process information";
  let subTitleText = "Add/update process information through file";
  return (
    <Dialog
      fullScreen
      open={open} //change to false
      onClose={close}
      TransitionComponent={Transition}
    >
      <NewHeader
        handleClose={close}
        title={title}
        subtitle={subTitleText}
        padding={true}
      >
        <UploadNewRecord
          handleClose={close}
          batchDetails={batchDetails}
          // isUploadRMPMGRN={props.isUploadRMPMGRN}
          // isUploadDSBatch={props.isUploadDSBatch}
          // isUploadConsumptionInfo={props.isUploadConsumptionInfo}
          // isUploadRMPMAvailability={props.isUploadRMPMAvailability}
          // refreshFunc={props.refreshFunc}
        />
      </NewHeader>
    </Dialog>
  );
};
export default UploadRecords;
